import React from 'react';
import LOOKUP from 'constants/lookup';
import { mapOrders } from 'utils/mappers';
import GenericTable from 'screens/components/advanced/GenericTable';
import Pagination from 'screens/components/basic/Pagination';
import CardSimple from 'screens/components/basic/CardSimple';

const OrderHistory = ({ orders, pagination, changePage }) => {
    const compName = "orders";
    return (
        <div className="product-content list-table">
            <CardSimple>
                <GenericTable
                    className="table_center"
                    multiSelectable={false}
                    enableSelectAll={false}
                    displaySelectAll={false}
                    adjustForCheckbox={false}
                    displayRowCheckbox={false}
                    selectable={false}
                    stripedRows={true}
                    columns={LOOKUP.menu.admin.orderListTableColumns}
                    rows={mapOrders(orders.list)}
                />
                <Pagination
                    length={orders.total}
                    itemsPerPage={pagination.itemsPerPage}
                    activePage={pagination.activePage}
                    onPageChange={(e) => changePage(e, compName)}
                />
            </CardSimple>
        </div>
    )
}

export default OrderHistory;
